import { playerDataHttpClient } from "@sazka/ng/player/http-clients/player-data-http-client";
import { httpClient } from "@sazka/utils/http-clients/http-client";
import { BonusomatAllwynDraw } from "../models/bonusomat-draw";
import { BonusomatLogoutBoardGame, BonusomatLogoutBoard } from "../models/bonusomat-logout-board";
import { BonusomatLogoutDefaultDraw } from "../models/bonusomat-logout-draw";
import { BonusomatLogoutQuest } from "../models/bonusomat-logout-quest";
import { BonusomatOnboarding } from "../models/bonusomat-onboarding";

export const fetchLogoutPlayerBoard = async () => {
    const response = await playerDataHttpClient.get<BonusomatLogoutBoard>(`/bonusomat/board`);

    return response.data;
};

export const fetchLogoutDefaultDraw = async () => {
    const response = await playerDataHttpClient.get<BonusomatLogoutDefaultDraw>(`/bonusomat/draw`);

    if (response.status == 204) {
        return null;
    }

    return response.data;
};

export const fetchLogoutAllwynDraw = async () => {
    const response = await playerDataHttpClient.get<BonusomatAllwynDraw>(`/bonusomat/allwyn-draw`);

    if (response.status == 204) {
        return null;
    }

    return response.data;
};

export const fetchLogoutQuests = async () => {
    const response = await playerDataHttpClient.get<BonusomatLogoutQuest[]>(`/bonusomat/quests`);

    if (response.data.length) {
        response.data.forEach((quest) => {
            quest.completedTasks = 0;
            quest.id = 0;
            quest.awardIcon = "Coin";

            quest.tasks.forEach((task) => {
                task.progress = 0;
                task.games = [];
            });
        });
    }

    return response.data;
};

export const fetchLogoutGames = async () => {
    const response = await httpClient.get<BonusomatLogoutBoardGame[]>(`/api/casino/games/bonusomat`);

    return response.data;
};

export const fetchLogoutOnboarding = async () => {
    const response = await playerDataHttpClient.get<BonusomatOnboarding>(`/bonusomat/onboarding`);

    return response.data;
};
